<div class="menu" [style.width]="menuWidth" (window:keydown.alt.m)="toggleMenu()" (window:keydown.alt.arrowdown)="nextMenuItemIndex()" (window:keydown.alt.arrowup)="previousMenuItemIndex()">
  <div *ngFor="let menuItem of menuItems; index as index">
    <div class="menu-item" [class.selected]="menuItemIndex === index" [class.hidden]="menuItem.hidden" (click)="menuItemSelected(index, menuItem)">
      <div class="icon {{menuItem.icon}}" [title]="menuItem.label"></div>
      <div class="label">{{menuItem.label}}</div>
    </div>
    <hr *ngIf="menuItem.separator" class="separator">
  </div>
</div>
